
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Pagination/Pagination.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Pagination.html');
        
        var script = require('./Pagination.ts').default;
        module.exports = require('./Pagination.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    